import {
  FETCH_GROUPTYPES_SUCCESS,
  GROUPTYPES_FAILURE
} from 'actions/types'
import { produce } from "immer";

const initialState = {
  GroupTypes: [],
  error: ''
}

const groupTypesReducer = (state = initialState, action) => 
  produce(state, draft => {
    switch (action.type) {
      case FETCH_GROUPTYPES_SUCCESS: 
        
        draft.GroupTypes = action.payload
        draft.error = ''
        return
      case GROUPTYPES_FAILURE:
        
        draft.error = action.payload
        return
      default:
        return draft
    }
  })


export default groupTypesReducer    